import { TransactionStatus } from "../api/transactions.api";

/**
 * Converts a transaction status to a human descriptor
 */
export const transactionStatusToHuman = (status: TransactionStatus): string => {
  switch (status) {
    case TransactionStatus.REQUIRES_PAYMENT_METHOD:
    case TransactionStatus.REQUIRES_CONFIRMATION:
      return "error";
    case TransactionStatus.REQUIRES_ACTION:
      return "authentication required";
    case TransactionStatus.PROCESSING:
      return "processing";
    case TransactionStatus.CANCELED:
      return "canceled";
    case TransactionStatus.REQUIRES_CAPTURE:
      return "pending";
    case TransactionStatus.SUCCEEDED:
      return "paid";
    case TransactionStatus.FAILED:
      return "failed";
  }
};
